import { Component } from '@angular/core';
import { ButtonComponent } from '../core/buttons/button.component';
import { ColumnComponent } from '../core/table/column.component';
import { TableComponent } from '../core/table/table.component';

@Component({
  selector: 'app-table-design',
  imports: [TableComponent, ColumnComponent, ButtonComponent],
  template: `
    <app-table
      #table
      [dataSource]="dataSource"
      [showSelection]="true"
      selectionKey="recordId"
      [expandable]="true"
    >
      <app-column name="recordId" label="Id" />
      <app-column name="claimNumber" label="Claim">
        <ng-template let-data>
          <a>{{ data.claimNumber }}</a>
        </ng-template>
      </app-column>
      <app-column name="lastName" label="Name">
        <ng-template let-data>
          {{ data.firstName }} {{ data.lastName }}
        </ng-template>
      </app-column>
      <app-column name="eventDate" label="Event date" format="d" />
      <app-column name="accessedDate" label="Accessed date" format="dt" />
      <app-column name="line" label="Line" />
      <app-column name="claimType" label="Claim Type" />
      <app-column name="coverage" label="Coverage" />
      <app-column name="claimStatus" label="Claim status" />
      <app-column name="totalIncurred" label="Total incurred" format="c" />
      <app-column name="clientNum" label="Client">
        <ng-template let-data>
          {{ data.clientNum }} - {{ data.clientName }}
        </ng-template>
      </app-column>
      <app-column name="accountNum" label="Account">
        <ng-template let-data>
          {{ data.accountNum }} - {{ data.accountName }}
        </ng-template>
      </app-column>
      <app-column name="unitNum" label="Unit">
        <ng-template let-data>
          {{ data.unitNum }} - {{ data.unitName }}
        </ng-template>
      </app-column>
      <ng-template #expand><div>Im the expanded row</div></ng-template>
    </app-table>
    <div class="tw-py-4">
      <app-button
        label="Add"
        [disabled]="!table.selectedCount"
        [badgeLabel]="table.selectedCount ? table.selectedCount : null"
      >
      </app-button>
      selected: {{ table.selectedCount }} rows: {{ table.dataSource?.length }}
    </div>
  `,
  styles: ``,
})
export class TableDesignComponent {
  dataSource: any[] = [
    {
      recordId: 235306351.904,
      recordSource: 'J',
      claimNumber: 'C267000376000101',
      fileNumberFormat: 'X9999X9999-9999-99',
      firstName: 'Paulo',
      lastName: 'Aurelio',
      eventDate: '2022-06-14T00:00:00',
      line: 'DS',
      coverage: 'SD',
      accessedDate: '2024-12-06T15:23:43',
      claimStatus: 'O',
      totalIncurred: 0,
      clientName: 'International Paper Company',
      claimType: 'SD',
      clientNum: 703,
      accountNum: 100,
      accountName: 'BE and K',
      unitNum: '000210',
      unitName: 'Ticonderoga Mill',
    },
    {
      recordId: 2155371,
      recordSource: 'T',
      claimNumber: 'C102260070300016TC',
      firstName: 'CARL F',
      lastName: 'JACKSON JR',
      eventDate: '0001-01-01T00:00:00',
      line: 'LA',
      coverage: 'LA',
      accessedDate: '2024-12-05T11:36:29',
      claimStatus: 'C',
      totalIncurred: 0,
      clientName: 'International Paper Company',
      clientNum: 703,
      accountNum: 7030000,
      accountName: 'IP Locations',
      unitNum: '000195',
      unitName: 'Carson Container',
    },
    {
      recordId: 235305331.904,
      recordSource: 'J',
      claimNumber: 'C267000362000101',
      fileNumberFormat: 'X9999X9999-9999-99',
      firstName: 'Hugh',
      lastName: 'Rouse',
      eventDate: '2022-03-02T00:00:00',
      line: 'WC',
      coverage: 'WC',
      accessedDate: '2024-12-05T11:02:50',
      claimStatus: 'O',
      totalIncurred: 625,
      clientName: 'International Paper Company',
      claimType: 'MO',
      clientNum: 703,
      accountNum: 1300,
      accountName: "Mitchell's Contracting",
      unitNum: '002151',
      unitName: 'Pine Hill Mill, AL',
    },
    {
      recordId: 235306352.904,
      recordSource: 'J',
      claimNumber: 'C267000376000101',
      fileNumberFormat: 'X9999X9999-9999-99',
      firstName: 'Paulo',
      lastName: 'Aurelio',
      eventDate: '2022-06-14T00:00:00',
      line: 'DS',
      coverage: 'SD',
      accessedDate: '2024-12-06T15:23:43',
      claimStatus: 'O',
      totalIncurred: 0,
      clientName: 'International Paper Company',
      claimType: 'SD',
      clientNum: 703,
      accountNum: 100,
      accountName: 'BE and K',
      unitNum: '000210',
      unitName: 'Ticonderoga Mill',
    },
    {
      recordId: 2155372,
      recordSource: 'T',
      claimNumber: 'C102260070300016TC',
      firstName: 'CARL F',
      lastName: 'JACKSON JR',
      eventDate: '0001-01-01T00:00:00',
      line: 'LA',
      coverage: 'LA',
      accessedDate: '2024-12-05T11:36:29',
      claimStatus: 'C',
      totalIncurred: 0,
      clientName: 'International Paper Company',
      clientNum: 703,
      accountNum: 7030000,
      accountName: 'IP Locations',
      unitNum: '000195',
      unitName: 'Carson Container',
    },
    {
      recordId: 235305332.904,
      recordSource: 'J',
      claimNumber: 'C267000362000101',
      fileNumberFormat: 'X9999X9999-9999-99',
      firstName: 'Hugh',
      lastName: 'Rouse',
      eventDate: '2022-03-02T00:00:00',
      line: 'WC',
      coverage: 'WC',
      accessedDate: '2024-12-05T11:02:50',
      claimStatus: 'O',
      totalIncurred: 625,
      clientName: 'International Paper Company',
      claimType: 'MO',
      clientNum: 703,
      accountNum: 1300,
      accountName: "Mitchell's Contracting",
      unitNum: '002151',
      unitName: 'Pine Hill Mill, AL',
    },
    {
      recordId: 235306353.904,
      recordSource: 'J',
      claimNumber: 'C267000376000101',
      fileNumberFormat: 'X9999X9999-9999-99',
      firstName: 'Paulo',
      lastName: 'Aurelio',
      eventDate: '2022-06-14T00:00:00',
      line: 'DS',
      coverage: 'SD',
      accessedDate: '2024-12-06T15:23:43',
      claimStatus: 'O',
      totalIncurred: 0,
      clientName: 'International Paper Company',
      claimType: 'SD',
      clientNum: 703,
      accountNum: 100,
      accountName: 'BE and K',
      unitNum: '000210',
      unitName: 'Ticonderoga Mill',
    },
    {
      recordId: 2155373,
      recordSource: 'T',
      claimNumber: 'C102260070300016TC',
      firstName: 'CARL F',
      lastName: 'JACKSON JR',
      eventDate: '0001-01-01T00:00:00',
      line: 'LA',
      coverage: 'LA',
      accessedDate: '2024-12-05T11:36:29',
      claimStatus: 'C',
      totalIncurred: 0,
      clientName: 'International Paper Company',
      clientNum: 703,
      accountNum: 7030000,
      accountName: 'IP Locations',
      unitNum: '000195',
      unitName: 'Carson Container',
    },
    {
      recordId: 235305333.904,
      recordSource: 'J',
      claimNumber: 'C267000362000101',
      fileNumberFormat: 'X9999X9999-9999-99',
      firstName: 'Hugh',
      lastName: 'Rouse',
      eventDate: '2022-03-02T00:00:00',
      line: 'WC',
      coverage: 'WC',
      accessedDate: '2024-12-05T11:02:50',
      claimStatus: 'O',
      totalIncurred: 625,
      clientName: 'International Paper Company',
      claimType: 'MO',
      clientNum: 703,
      accountNum: 1300,
      accountName: "Mitchell's Contracting",
      unitNum: '002151',
      unitName: 'Pine Hill Mill, AL',
    },
    {
      recordId: 235306351.904,
      recordSource: 'J',
      claimNumber: 'C267000376000101',
      fileNumberFormat: 'X9999X9999-9999-99',
      firstName: 'Paulo',
      lastName: 'Aurelio',
      eventDate: '2022-06-14T00:00:00',
      line: 'DS',
      coverage: 'SD',
      accessedDate: '2024-12-06T15:23:43',
      claimStatus: 'O',
      totalIncurred: 0,
      clientName: 'International Paper Company',
      claimType: 'SD',
      clientNum: 703,
      accountNum: 100,
      accountName: 'BE and K',
      unitNum: '000210',
      unitName: 'Ticonderoga Mill',
    },
    {
      recordId: 235306351.904,
      recordSource: 'J',
      claimNumber: 'C267000376000101',
      fileNumberFormat: 'X9999X9999-9999-99',
      firstName: 'Paulo',
      lastName: 'Aurelio',
      eventDate: '2022-06-14T00:00:00',
      line: 'DS',
      coverage: 'SD',
      accessedDate: '2024-12-06T15:23:43',
      claimStatus: 'O',
      totalIncurred: 0,
      clientName: 'International Paper Company',
      claimType: 'SD',
      clientNum: 703,
      accountNum: 100,
      accountName: 'BE and K',
      unitNum: '000210',
      unitName: 'Ticonderoga Mill',
    },
  ];
}
